import {
  AfterViewInit,
  Component,
  EventEmitter,
  Injector,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { NotificationsService } from '@app/components/notification/NotificationsService';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { PrModalConfirmComponent } from '@app/components/pr-modal/pr-modal-confirm/pr-modal-confirm.component';
import { ProductDao } from '@app/dao/product/product.dao';
import { CommandEnum } from '@app/forms/subscription/definition/interface/enum';
import { PledgeRead } from '@app/forms/subscription/definition/interface/Pledge';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'credit-tarification',
    templateUrl: './credit-tarification.component.html',
    styleUrls: ['./credit-tarification.component.scss'],
    standalone: false
})
export class CreditTarificationComponent
  extends EaSubscriptionBuilder
  implements OnInit, AfterViewInit
{
  @ViewChild(PrModalConfirmComponent, { static: true })
  modal: PrModalConfirmComponent;

  loading: boolean = false;
  loadingDownloadDocuments: boolean = false;
  pledge: PledgeRead;

  productSelectedKeyPoints: any = [];

  smoothingFeesDurationRef: any[] = [
    {
      id: 'AUCUN',
      label: 'Aucun',
    },
    {
      id: 'UN',
      label: '1 mois',
    },
    {
      id: 'TROIS',
      label: '3 mois',
    },
    {
      id: 'SIX',
      label: '6 mois',
    },
    {
      id: 'NEUF',
      label: '9 mois',
    },
    {
      id: 'DOUZE',
      label: '12 mois',
    },
  ];
  codeConfiguration: string[] = ['L20', 'L15', 'L10', 'L5', 'L0'];

  @Output() onConfirm = new EventEmitter<any>();

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected productDao: ProductDao,
    private notificationsService: NotificationsService,
    protected injector: Injector,
  ) {
    super(formConstructor);
  }

  ngAfterViewInit(): void {}

  ngOnInit() {
    this.pledge = this.subscriptionFacade.getPledge();
    this.subscriptionFacade.initForm(this);
  }
  onSubmit() {
    this.form.markAsDirty();
    console.log({ this: this });

    this.subscriptionFacade.submitPledge(this);
  }

  regenerateTarification() {
    this.form.markAsDirty();
    console.log('toto');
    console.log({ this: this });
    this.subscriptionFacade.setCommand([
      CommandEnum.GENERATE_TARIFICATION_BORROWER_INSURANCE,
    ]);
    this.subscriptionFacade.submitPledgeWithoutNextStep(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }

  get tarifications() {
    return this.form
      .get('products')
      .get('0')
      .get('parameters')
      .get('tarifications') as UntypedFormArray;
  }

  toggleTarification(productCode: string) {
    this.form
      .get('products')
      .get('0')
      .get('parameters')
      .get('choosedProductCode')
      .setValue(productCode);
  }

  onKeyPointsClick($event, tarif) {
    $event.stopPropagation();
    const tarification = tarif?.value;
    if (tarification?.product && tarification?.product?.keyPoints?.length) {
      this.productSelectedKeyPoints = tarification.product.keyPoints;
    }
    this.modal.open();
  }

  onDownloadLinks($event, tarif, documentType: string) {
    $event.stopPropagation();
    this.loadingDownloadDocuments = true;
    const { insurerReference, product } = tarif?.value;
    this.productDao
      .downloadDigitalInsureTarificationDocument(
        product.code,
        insurerReference,
        documentType,
      )
      .subscribe({
        next: blob => {
          this.loadingDownloadDocuments = false;
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = `${product.code}-${documentType === 'GENERAL_CONDITIONS' ? 'conditions-generales' : 'devis'}.pdf`;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        },
        error: () => {
          this.loadingDownloadDocuments = false;
          this.notificationService.error(
            "Une erreur s'est produite lors du téléchargement du document.",
          );
        },
      });
  }
  confirmModal() {}
}
